import { Injectable } from '@angular/core';
import { switchMap, take } from 'rxjs/operators';
import { Rate } from '@core/models/Rate/Rate.model';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.reducer';
import { RoomBookingService } from '@core/services/room-booking.service';
import { CheckRoomService } from '@core/services/check-room.service';
import { RateStatus } from '../../../shared/enums/rate-status.enum';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RateService {
  private hotelAvailability: any;

  constructor(
    private store: Store<AppState>,
    private roomBookingService: RoomBookingService,
    private checkRoomRateService: CheckRoomService,
  ) {
    this.store
      .select('hotelsAvailability')
      .pipe(take(1))
      .subscribe((hotelAvailability) => {
        this.hotelAvailability = hotelAvailability.hotelAvailability;
      });
  }

  public bookReservation(rate: Rate): Observable<Rate> {
    if (
      rate.status === RateStatus.CHECKED_NO_CHANGE ||
      rate.status === RateStatus.CHECKED_CHANGE
    ) {
      return this.roomBookingService.bookRate(rate, this.hotelAvailability).pipe(
        take(1),
        switchMap((res: any) => {
          window.location.href =
            window.location.protocol +
            '//' +
            `${res.urlToRedirect}&currencyCode=${rate.price.currency.code}`;
          return of(rate);
        }),
      );
    } else {
      this.checkRoomRateService.getRoomRate(rate).pipe(
        switchMap((res: any) => {
          if (RateStatus.CHECKED_NO_CHANGE) {
            return this.bookReservation(res);
          }
          return res;
        }),
      );
    }
  }
}
